var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return true
    ? _c(
        "CustomModal",
        {
          staticClass: "basic-modal my-quiz-modal",
          attrs: { id: "my-quiz-modal", isCustomFooter: true }
        },
        [
          _c(
            "div",
            {
              staticClass: "quiz-title",
              attrs: { slot: "modal-header" },
              slot: "modal-header"
            },
            [
              _vm._v("\n    데일리 퀴즈 상세\n    "),
              _c("div", { staticClass: "quiz-subtitle" }, [
                _vm._v("\n      검토 완료 이후 퀴즈 수정이 불가능합니다.\n    ")
              ])
            ]
          ),
          _vm._v(" "),
          _c("QuizPreview", { attrs: { quiz: _vm.quiz } }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              },
              [_vm._v("\n      취소\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.isActiveQuiz ||
                    _vm.isEndQuiz ||
                    _vm.isReviewCompletedQuiz
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("ok")
                  }
                }
              },
              [_vm._v("\n      수정\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: {
                  type: "button",
                  disabled: _vm.isActiveQuiz || _vm.isReviewCompletedQuiz
                },
                on: { click: _vm.handleDeleteClick }
              },
              [!_vm.isLoading ? [_vm._v("삭제")] : _c("LoadingBounce")],
              2
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456438ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-456438ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-quizzes/components/MyQuizModal.vue
// module id = pO6y
// module chunks = 1